"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockMitekDecision = void 0;
var deprecated_1 = require("./deprecated");
Object.defineProperty(exports, "mockMitekDecision", { enumerable: true, get: function () { return deprecated_1.mockMitekDecision; } });
//# sourceMappingURL=index.js.map